import StoreGetDirections from '@components/storelocator/StoreGetDirections';
import React, { useMemo } from 'react';
const Address = (props) => {
    var _a;
    const addressEmail = useMemo(() => {
        return props.address.emailShipping || props.address.email;
    }, [props.address]);
    if (!props.address) {
        return React.createElement(React.Fragment, null);
    }
    console.log(props.address);
    function getLine2() {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
        if (window.country == 'US' || window.country == 'CA') {
            return (React.createElement(React.Fragment, null,
                React.createElement("p", { className: "address" },
                    props.address.address1,
                    " ",
                    props.address.address2,
                    ", ",
                    props.address.city,
                    " ", (_a = props.address) === null || _a === void 0 ? void 0 :
                    _a.stateCode,
                    " ",
                    props.address.postalCode,
                    ' ',
                    !props.nocountry && ` ${(_c = (_b = props.address) === null || _b === void 0 ? void 0 : _b.countryCode) === null || _c === void 0 ? void 0 : _c.displayValue}`)));
        }
        let statecode = '';
        if (((_e = (_d = props.address) === null || _d === void 0 ? void 0 : _d.countryCode) === null || _e === void 0 ? void 0 : _e.value) == 'JP' || ((_g = (_f = props.address) === null || _f === void 0 ? void 0 : _f.countryCode) === null || _g === void 0 ? void 0 : _g.value) == 'KR') {
            statecode = (_h = props.address) === null || _h === void 0 ? void 0 : _h.stateCode;
        }
        if (window.country == 'JP') {
            return (React.createElement(React.Fragment, null,
                React.createElement("p", { className: "address" },
                    props.address.postalCode,
                    " ",
                    statecode || '',
                    " ",
                    props.address.city,
                    " ",
                    !props.nocountry && ` ${(_k = (_j = props.address) === null || _j === void 0 ? void 0 : _j.countryCode) === null || _k === void 0 ? void 0 : _k.displayValue}`,
                    ", ",
                    props.address.address1,
                    ' ',
                    props.address.address2)));
        }
        return (React.createElement(React.Fragment, null,
            React.createElement("p", { className: "address" },
                props.address.address1,
                " ",
                props.address.address2,
                ", ",
                props.address.postalCode,
                " ",
                props.address.city,
                " ",
                statecode || '',
                ' ',
                !props.nocountry && ` ${(_m = (_l = props.address) === null || _l === void 0 ? void 0 : _l.countryCode) === null || _m === void 0 ? void 0 : _m.displayValue}`)));
    }
    return (React.createElement("div", { className: "section-details" },
        React.createElement("p", { className: "name" }, window.country == 'JP' ? `${props.address.lastName} ${props.address.firstName}` : `${props.address.firstName} ${props.address.lastName}`),
        props.address.companyName && React.createElement("p", null, props.address.companyName),
        getLine2(),
        addressEmail && (React.createElement("p", { title: addressEmail, className: "ellipsed-email" },
            React.createElement("span", { "aria-hidden": "true" }, addressEmail))),
        (props === null || props === void 0 ? void 0 : props.pickUpInOffice) && ((_a = props === null || props === void 0 ? void 0 : props.customer) === null || _a === void 0 ? void 0 : _a.phone) && (React.createElement("p", { className: "tel" },
            props.customer.phonePrefix || '',
            " ",
            props.customer.phone)),
        props.address.phone && !props.nophone && !(props === null || props === void 0 ? void 0 : props.pickUpInOffice) && (React.createElement("p", { className: "tel" },
            props.address.phonePrefix || '',
            " ",
            props.address.phone)),
        props.directions && React.createElement(StoreGetDirections, { store: props.directions })));
};
export default Address;
